import { risapi, getAxiosConfig, getAPIFullUrl } from './risapi';
import { convertJsonToFormData } from '../commonfunctions';

export const getUsers = async (filters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/users', filters), getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const fetchUser = async (id, callback) => {
     try {
        const response = await risapi.get(`/api/users/${id}`, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const createUser = async (data, callback) => {
    try {
        const formData = convertJsonToFormData(data);
        // We use post for file uploads
        const config = getAxiosConfig();
        config.headers['Content-Type'] = 'multipart/form-data';
        const response = await risapi.post('/api/users', formData, config);
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const updateUser = async (data, callback) => {
    try {
        const formData = convertJsonToFormData(data);
        formData.append('_method', 'put');
        const config = getAxiosConfig();
        config.headers['Content-Type'] = 'multipart/form-data';
        const response = await risapi.post(`/api/users/${data.id}`, formData, config);
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const destroyUser = async (user, callback) => {
    try {
        const response = await risapi.delete(`/api/users/${user.id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ user });
        }
    } catch (error) {
        callback(error);
    }
};


/**
 * Fetches the career cricket statistics for a specific user.
 * THIS IS THE NEW FUNCTION.
 */
export const getUserStats = async (userId, callback) => {
    try {
        const response = await risapi.get(`/api/users/${userId}/stats`, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};